import { Timestamp } from '@angular/fire/firestore';

export interface UserInterface {
  id: string;
  email: string;
  username: string;
  tel: string;
  title: string;
  role: UserRole;
  createdAt: Timestamp;
}

export enum UserRole {
  Admin = 'Admin',
  User = 'User',
}

export interface Booking {
  id: string | undefined;
  ship: ShipInterface;
  duration: DurationInterface;
  createdDate: Timestamp;
  userCreatorId: string;
  userCreatorName: string;

  cruiseDetails?: CruiseDetailsInterface;
  busInfos?: BusInfoInterface;
  driverInfo?: DriverInfoInterface;
  guides?: Record<string, newGuideInterface>;
  guideOrder?: string[];
  guideIds?: string[];
  rundown?: string;
  voucherAddonText?: string;

  deleteFlag?: boolean;

  pdfUrl?: string;
  voucher?: VoucherInterface | null;

  accountingNote?: string;
  accounting?: AccountingInterface;

  changes?: BookingChange[];
  hash?: string;
}

export interface AccountingInterface {
  id: string;
  accountingNote?: string;

  billing?: {
    billed?: boolean;
    dateBilled?: Timestamp;
    userBilledId?: string;
    userBilledName?: string;
  };
}

export interface ShipInterface {
  id: string;
  companyName: string;
  shipName: string;
  createdDate: Timestamp;
  lastEditDate: Timestamp;
  receptionTel?: string;
  shipEmail?: string;
  shipDrRichardNr?: string;
}

export interface BusInfoInterface {
  busCompany: string;
  selectedBuses: Record<string, number>;
}

export interface GuideDetailInterface {
  id: string;
  forename: string;
  surname: string;
  tel: string;
  email: string;
  languages: Record<string, boolean>;
  tAndC: boolean;
}

export interface newGuideInterface {
  id: string;
  guideDetails: GuideDetailInterface;
  other: Record<string, string>;
  positionDetails: PosTimeInterface;
  storno: StornoInterface;
  tour: TourInterface;
}

export interface StornoInterface {
  storno: string;
  customStorno: string;
  isActive: boolean;
}

export interface TourInterface {
  id: string;
  tourInfo: TourDetailInterface;
  tourLanguage: string;
  tourConfirm: boolean;
}

export interface TourDetailInterface {
  id: string;
  tourName: string;
  createdDate: Timestamp;
  lastEditDate: Timestamp;
  colorCode?: string;
}

export interface PosTimeInterface {
  id: string;
  time: Timestamp;
  location: string;
}

export interface DurationInterface {
  date: Timestamp;
  startTime: Timestamp;
  endTime: Timestamp;
  tourCode?: string;
}

export interface CruiseDetailsInterface {
  cruiseManager: string;
  cruiseManagerTel: string;
  jetty: string;
  paxShip: number;
  paxTour: number;
  internNote: string;
  invoiceNumber: string;
}

export interface CruiseManagerInterface {
  id: string;
  name: string;
  tel: string;
  email?: string;
}

export interface DriverInfoInterface {
  url: string;
  customerNumber: number;
  orderNumber: number;
  drivers?: Record<number, DriverDetailInterface>;
}

export interface DriverDetailInterface {
  driverName: string;
  driverTel: string;
}

export interface BookingChange {
  timestamp: Timestamp;
  changeAuthor: ChangeAuthor;
  changeType: ChangeEventType;
  changes: Partial<Booking>;
}

export interface ChangeAuthor {
  id: string;
  name: string;
  email: string;
  tel: string;
  title: string;
}

export enum ChangeEventType {
  COPY = 'COPY',
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
}

export interface VoucherInterface {
  id: string | undefined;
  bookingHash?: string;
  voucherUrl?: string;
  ship: ShipInterface;
  duration: DurationInterface;
  createdDate: Timestamp;
  guideAmount: number;
  tourList: Record<string, number>;
  cruiseDetails?: CruiseDetailsInterface;
  busInfos?: BusInfoInterface;
  addonText?: string;
}

export interface EmailInterface {
  to: string[];
  from: string;
  subject: string;
  textBody: string;
  htmlBody: string;
  pdfUrl?: string;
  voucherUrl?: string;
  formatedDate: string;
  tourCode: string;
  invoiceNr: string;
}

export interface SourceMaps {
  shipMap: Map<string, ShipInterface>;
  guideMap: Map<string, GuideDetailInterface>;
  busCompanyMap: { [key: string]: string };
  tourMap: Map<string, TourDetailInterface>;
  jettyMap: { [key: string]: string };
  stornoMap: { [key: string]: string };
}

export interface FilterState {
  selectedCompanies: string[];
  selectedShip: string;
  savedDate: string | null;
  loadedBookings: Booking[] | [];
  searchTerm: string;
  showEmpty: boolean;
}

export interface CsvPreviewData extends Booking {
  isValid: boolean;
  errors: CsvImportError[];
  id: string;
  selected?: boolean;
}

export interface CsvImportError {
  row: number;
  message: string;
}

export type Scope = 'bootstrap' | 'editor';
